import { cyan, green, lime, orange, presetPalettes, purple, red, volcano } from '@ant-design/colors';
import { ColorPicker, ColorPickerProps, Form } from 'antd';
import React, { Suspense } from 'react';

import { IFieldBase } from '../interfaces';
import { ItemType } from '../types';

const predefine: string[] = ['#d6cde6', '#b9e15c', '#abe0fc', '#f5cfbc', '#f7b9b9', '#e8b8f5', '#b8c4f5', '#abe7e1'];

const FieldColorPicker: React.FC<IFieldBase> = ({ disabled }) => {
    const genPresets = (presets = presetPalettes) =>
        Object.entries(presets).map(([label, colors]) => ({ label, colors }));

    const customPanelRender: ColorPickerProps['panelRender'] = (_, { components: { Presets } }) => (
        <div style={{ height: 300, overflow: 'scroll' }}>
            <Presets />
        </div>
    );

    const previousUse: string[] = [];

    const setPresets: { [key: string]: string[] } = {};

    if (predefine.length) {
        setPresets['Predefine'] = predefine;
        setPresets['Cyan'] = cyan.slice(0, 8);
        setPresets['Red'] = red.slice(0, 8);
        setPresets['Green'] = green.slice(0, 8);
        setPresets['Purple'] = purple.slice(0, 8);
        setPresets['Volcano'] = volcano.slice(0, 8);
        setPresets['Volcano'] = volcano.slice(0, 8);
        setPresets['Orange'] = orange.slice(0, 8);
        setPresets['Lime'] = lime.slice(0, 8);
    }

    if (previousUse.length) {
        setPresets['Previous use'] = previousUse;
    }

    const presets = genPresets(setPresets);

    return (
        <Form.Item<ItemType>
            label="Color"
            name="color"
            getValueFromEvent={(color) => {
                return '#' + color.toHex();
            }}
        >
            <ColorPicker
                size="small"
                format={'hex'}
                presets={presets}
                disabled={disabled}
                panelRender={customPanelRender}
            />
        </Form.Item>
    );
};

const FieldColor: React.FC<IFieldBase> = ({ disabled }) => {
    return (
        <Suspense fallback={<ColorPicker size="small" format={'hex'} disabled />}>
            <FieldColorPicker disabled={disabled} />
        </Suspense>
    );
};

export default React.memo(FieldColor);
